import React from 'react';

const SettingsPanelBody: React.FC<{ children: React.ReactNode; fill?: boolean }> = ({ children, fill }) => (
  <div style={{
    flex: 1,
    minWidth: 0,
    height: '100%',
    overflowY: fill ? 'hidden' : 'auto',
    padding: fill ? 0 : 12,
    display: fill ? 'flex' : undefined,
    flexDirection: fill ? 'column' : undefined,
    '--bg-form':                  'var(--surface)',
    '--bg-top':                   'var(--surface2)',
    '--btn-user-form':            'var(--surface2)',
    '--btn-user-btn':             'var(--surface)',
    '--btn-user-hover':           'var(--surface)',
    '--bg-input':                 'var(--surface)',
    '--background-color':         'var(--surface2)',
    '--border-input':             '1px solid var(--border-new)',
    '--border-input-one':         '1px solid var(--border2-new)',
    '--border-input-two':         '1px solid var(--border2-new)',
    '--text-color':               'var(--text-new)',
    '--text-color-calendar':      'var(--text2-new)',
    '--text-color-calendar-week': 'var(--text2-new)',
  } as React.CSSProperties}>
    {children}
  </div>
);

export default SettingsPanelBody;
